// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c521","col":"styles_col__2QLIE"};